const addOrder = {
    state: {
        dataList: []
    },
    mutations: {
        // 选择分型--提交
        initDataList (state, data) {
            state.dataList = data
        },
        // 分型列表 -- 删除
        dleDataList (state, data) {
            delete state.dataList[data]
        }
    },
    actions: {
        increaseAsync ({state, commit}) {
            commit('increase')
        }
    }
}
export default addOrder



// WEBPACK FOOTER //
// ./src/store/modules/addOrder.js